/**
 * DataToolbar Component
 * Container for toolbar controls (search, filters, sort, view toggle)
 */
import React from "react";
import PropTypes from "prop-types";
import "./DataToolbar.scss";

export const DataToolbar = ({ children, className = "" }) => {
  return <div className={`data-toolbar ${className}`}>{children}</div>;
};

DataToolbar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
